import { useEffect, useState } from 'react';
import { isYdCourseApp } from '../util'
import { UserData } from 'fetch'

export function useYdCourseApp(webUserInfo: UserData|null|undefined) {
  const [isYdCourseAppWebView, setIsYdCourseAppWebview] = useState<boolean|undefined>();
  const [isLogin, setIsLogin] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  const [ydkReady, setYdkReady] = useState(false);

  useEffect(() => {
    const isYouDaoCourseApp = isYdCourseApp();
    let timer: NodeJS.Timer;
    if (isYouDaoCourseApp) {
      timer = setInterval(() => {
        if (window.ydk) {
          window.isYdkReady = true;
          setYdkReady(true);
          clearInterval(timer);
        }
      }, 0);
    }
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (window.isYdkReady) {
      setIsYdCourseAppWebview(true);
      window.ydk.isLogin({
        success(res: {isLogin: boolean}) {
          const { isLogin: isAppUserLogin, ...uInfo } = res;
          setIsLogin(isAppUserLogin);
          setUserInfo(uInfo || {});
        }
      });
    } else {
      setIsYdCourseAppWebview(false);
      setIsLogin(!!webUserInfo?.userId);
      setUserInfo(webUserInfo||{});
    }
  }, [ydkReady]);

  return {
    isYdCourseAppWebView,
    isLogin,
    userInfo,
    ydkReady
  };
}
